import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminDownloadComponent } from './admin-download/admin-download.component';
import { RoleGuard } from '../../guards/role.guard';
import { Role } from '../../models/role.model';
import { PrerequisitesGuard } from '../../guards/prerequisites.guard';
import { ServerConfigComponent } from './server-config/server-config/server-config.component';
import { LoginTrackerComponent } from './login-tracker/login-tracker.component';
import { AccountsComponent } from './accounts/accounts.component';
import { EmployeeRoleComponent } from './employee-role/employee-role.component';
import { CasesComponent } from './cases/cases.component';
import { UsersComponent } from './users/users.component';
import { AppContainerComponent } from "../layout/app-container/app-container.component";

const adminRoutes: Routes = [
	{
		path: 'admin',
		component: AppContainerComponent,
		children: [
			{
				path: 'server-configuration',
				component: ServerConfigComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Administrator, Role.Developer, Role.OperationsExpertFeatureSet] }
			},
			{
				path: 'download',
				component: AdminDownloadComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Operations, Role.Developer, Role.OperationsStandardFeatureSet] }
			},
			{
				path: 'login-tracker',
				component: LoginTrackerComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Administrator, Role.ProfessionalServices, Role.OperationsAdvancedFeatureSet] }
			},
			{
				path: 'employee-role',
				component: EmployeeRoleComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Administrator] }
			},
			{
				path: 'accounts',
				component: AccountsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Administrator, Role.ProfessionalServices, Role.GlobalAccountAdvancedFeatureSet, Role.OperationsAdvancedFeatureSet, Role.OperationsExpertFeatureSet] }
			},
			{
				path: 'cases',
				component: CasesComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Administrator, Role.ProfessionalServices, Role.GlobalAccountAdvancedFeatureSet, Role.OperationsExpertFeatureSet] }
			},
			{
				path: 'users',
				component: UsersComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Administrator, Role.ProfessionalServices, Role.GlobalAccountAdvancedFeatureSet] }
			}
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(adminRoutes)
	],
	exports: [
		RouterModule
	]
})
export class AdminRoutingModule {
}
